import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Transaction } from "@onmo/graphql/graphql";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { getRewardImages, getRewardTitle } from "../../../models/rewardHistory";
import { useWalletConfig } from "../../../hooks/useWalletConfig";
import { useStyles } from "./TransactionHistoryCard.style";

interface ITransactionHistoryCardProps {
  rewardsHistory?: Transaction;
  coinIcon?: {
    src: string;
    src2x: string;
    src3x: string;
  };
}

export const TransactionHistoryCard: FC<
  HTMLAttributes<HTMLDivElement> & ITransactionHistoryCardProps
> = (props) => {
  const classes = useStyles();
  const { rewardsHistory, coinIcon, className, ...otherProps } = props;
  const transactionHistoryImg = getRewardImages(rewardsHistory);
  const { spendableIcon } = useWalletConfig();
  const icon = coinIcon ?? spendableIcon;

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <div className={classes.item}>
        <StaticImage
          src={transactionHistoryImg?.src1x}
          src2x={transactionHistoryImg?.src2x}
          src3x={transactionHistoryImg?.src3x}
          className={classes.itemImg}
        />
        <Typography variant={TypographyVariant.BodyB4Bold}>
          {getRewardTitle(rewardsHistory)}
        </Typography>
      </div>
      <div className={clsx(classes.item, classes.coinItem)}>
        <StaticImage
          src={icon.src}
          src2x={icon.src2x}
          src3x={icon.src3x}
          className={classes.coinImg}
        />
        <Typography variant={TypographyVariant.HeadingH6Bold}>
          {rewardsHistory?.amount}
        </Typography>
      </div>
    </div>
  );
};
